/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/Actions/Options/Option",
  closePopover
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover
  
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 onClick={onClick}
 closePopover={closePopover}
 type="ghost"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="option.text"
 text={optionTextValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}